module.exports = __webpack_public_path__ + "p2_img1.png?577827b6913ed94a867323d3dc0b2ff0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p2/p2_img1.png
// module id = 50
// module chunks = 0